import m from 'mithril'

export default {
  view: vnode => {
    const outside = require('./outside.png')
    return (
      <div className={`log-book-page-content-inner log-book-page-template mod-16-page`}>
        <div className={`log-book-text-container ${vnode.attrs.unredacted ? 'is-unredacted' : 'is-redacted'}`}>
          <h3 className="log-book-text mod-h3">Camp Century - lokation og klima</h3> 
          <ul>
          <li><p className="log-book-text">Beliggenhed: Ca. 1910 meter over havets overflade. </p> </li>
          <p className="log-book-text">Luftfugtighed: Tør</p> 

          <li><p className="log-book-text">Temperatur</p> 
          <ul><li><p className="log-book-text">Lav: - 65 grader Fahrenheit (-54 grader celsius) </p></li> 
          <li><p className="log-book-text">Høj: 20 grader Fahrenheit (-7 grader celsius) </p></li></ul></li>
          </ul>

          <p className="log-book-text">Advarsel! Arktisk chill-faktor. Hvis det både blæser og er koldt, rammer ‘chill-faktoren’, og så kan det have alvorlige konsekvenser at bevæge sig op fra Camp Century. Ved blæst svarende til ‘frisk kuling’ og minus 32 grader celsius advarer det amerikanske militær: "Exposed areas of the face may freeze within one half-minute".</p> 
          <figure className="log-book-figure">
            <img src={outside} className="log-book-img" />
          </figure>
        </div>
      </div>
    )
  }
}
